import React from "react";

const Loading = ({ text, style }) => {
  return <div className={style}>{text}</div>;
};

export default Loading;
